export default __webpack_public_path__ + "static/media/login-dialog.233173d1.svg";